import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { CAPABILITIES } from "@/data/content";
import { scrollToSection } from "./Header";

const SLUGS = [
  "corporate-debt-advisory",
  "structured-finance",
  "private-credit",
  "project-finance",
  "working-capital",
  "capital-raising",
];

const Capabilities = () => (
  <section
    id="capabilities"
    data-testid="capabilities-section"
    className="border-t border-white/5 bg-[#0D1220]"
  >
    <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <SectionHeading number="02" label="Capabilities" title="Our capabilities" tone="dark" />
        <Reveal delay={0.1}>
          <p className="max-w-md text-base font-light leading-relaxed text-slate-400">
            Advisory across the financing spectrum — structured around the
            requirement, not the product.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-[#0D1220]/10 sm:grid-cols-2 lg:grid-cols-3">
        {CAPABILITIES.map((cap, i) => (
          <Reveal key={cap.title} delay={i * 0.06} className="h-full">
            <button
              data-testid={`capability-card-${SLUGS[i]}`}
              onClick={() => scrollToSection("contact")}
              className="group relative flex h-full w-full flex-col bg-[#0D1220] p-8 text-left transition-[background-color,transform,box-shadow] duration-500 hover:-translate-y-1 hover:bg-[#111827] hover:shadow-[0_24px_48px_-24px_rgba(0,0,0,0.6)]"
            >
              <span
                className="absolute left-0 top-0 h-0 w-px bg-[#F26122] transition-all duration-500 group-hover:h-full"
                aria-hidden="true"
              />
              <span
                className="absolute right-4 top-4 h-3 w-3 border-r border-t border-[#F26122]/0 transition-colors duration-500 group-hover:border-[#F26122]/70"
                aria-hidden="true"
              />
              <span className="font-mono2 text-[10px] tracking-[0.25em] text-slate-600 transition-colors duration-300 group-hover:text-[#F2824F]">
                0{i + 1}
              </span>
              <h3 className="mt-5 font-display text-xl font-normal text-slate-100 sm:text-2xl">
                {cap.title}
              </h3>
              <p className="mt-4 flex-1 text-sm font-light leading-relaxed text-slate-400">
                {cap.description}
              </p>
              <span className="mt-6 flex items-center gap-2 text-xs tracking-wide text-slate-500 transition-colors duration-300 group-hover:text-[#F26122]">
                Discuss this requirement
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Capabilities;
